import { useCallback } from 'react'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { editorThunks } from 'store/features/editor/thunks'
import { dispatch } from 'store'

export const useMobileInnerSliderCallbacks = (
  breakpoint = SMALL_DESKTOP_SIZE_BREAKPOINT
) => {
  const isMobile = useResponsive(breakpoint)

  const openCallback = useCallback(() => {
    if (isMobile) {
      dispatch(editorThunks.setIsMobileInnerSliderOpen(true))
    }
  }, [isMobile])

  const closeCallback = useCallback(() => {
    if (isMobile) {
      dispatch(editorThunks.setIsMobileInnerSliderOpen(false))
    }
  }, [isMobile])

  return { openCallback, closeCallback }
}
